import React from "react";
import {
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/outline";

const FooterSection = () => {
  return (
    <footer
      className="pt-16 pb-10 px-6 bg-[#111] text-white"
      style={{ fontFamily: "Poppins, Roboto, sans-serif" }}
    >
      {/* MAIN GRID */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

        {/* BRAND SECTION */}
        <div>
          <h3 className="text-2xl font-bold mb-4 tracking-tight">GTPL HRMS</h3>
          <p
            className="text-sm text-gray-300 leading-relaxed max-w-xs"
            style={{ fontFamily: "Roboto, sans-serif" }}
          >
            A unified HR platform built for GTPL’s teams — delivering fast,
            reliable and employee-first HR operations for everyday workflows.
          </p>
        </div>

        {/* QUICK ABOUT SECTION */}
        <div>
          <h4 className="text-sm font-semibold mb-4 tracking-wide uppercase">
            About
          </h4>

          <ul className="space-y-3 text-sm text-gray-300">
            <li>GTPL HRMS Platform</li>
            <li>Employee Operations</li>
            <li>Internal HR Tools</li>
            <li>System Compliance</li>
          </ul>
        </div>

        {/* FEATURE SNAPSHOT */}
        <div>
          <h4 className="text-sm font-semibold mb-4 tracking-wide uppercase">
            Modules
          </h4>

          <ul className="space-y-3 text-sm text-gray-300">
            <li>Attendance & Leave</li>
            <li>Payroll & Compliance</li>
            <li>Performance & Goals</li>
            <li>Recruitment & Onboarding</li>
            <li>Helpdesk & Tickets</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <h4 className="text-sm font-semibold mb-4 tracking-wide uppercase">
            Contact
          </h4>

          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-center gap-3">
              <PhoneIcon className="w-5 h-5 text-teal-400" />
              +91 98765 43210
            </li>

            <li className="flex items-center gap-3">
              <EnvelopeIcon className="w-5 h-5 text-teal-400" />
              support@gtplhrms.com
            </li>

            <li className="flex items-center gap-3">
              <BuildingOfficeIcon className="w-5 h-5 text-teal-400" />
              GTPL Corporate Office
            </li>

            <li className="flex items-center gap-3">
              <MapPinIcon className="w-5 h-5 text-teal-400" />
              Ahmedabad, Gujarat, India
            </li>
          </ul>
        </div>
      </div>

      {/* DIVIDER */}
      <div className="border-t border-gray-800 mt-12 pt-5"></div>

      {/* COPYRIGHT */}
      <div className="text-center text-xs md:text-sm text-gray-400">
        © {new Date().getFullYear()} GTPL HRMS • All Rights Reserved
      </div>
    </footer>
  );
};

export default FooterSection;
